import React, {Component} from 'react';
import { Upload, Icon, Empty, Button, Progress, Tooltip } from 'antd';
import { PIC_TYPE, VIDEO_TYPE, AUDIO_TYPE, ATTCHMENT_TYPE} from '../../constants';
import uploadIcon from './upload.png';
import uploadingIcon from './uploading.png';
import './uploadWall.css';
import PDF from './images/PDF.png'
import RAR from './images/RAR.png'
import TXT from './images/TXT.png'
import WORD from './images/Word.png'
import XLXS from './images/XLXS.png'
import ZIP from './images/zip.png'
import PPT from './images/ppt.png'
import AUDIO from './images/AUDIO.png'
import File from './images/other.png';
import {computeDuration, formatDate, formatTime, getSubffix, uuid} from "../../utils";
import {getInfoFromLocalStorage} from "../../actions";
import BaseComponent from "../../base/BaseComponent";
import videoIcon from "./fileItem/videoIcon.png";
import {DetailDialog as Picture} from "../../view/resource/view/dialog/picture/picture";
import {Video} from "../../view/resource/view/dialog/CurrencyResourceDialog";
import {DetailDialog as Audio} from "../../view/resource/view/dialog/audio/audio";


export const getFileImage = (url, ext)=>{
    if(VIDEO_TYPE.indexOf(ext) > -1){ //视频类型
        if(!url)
            return url;
        return url.replace(/(\/storage\/[a-zA-Z0-9]{32}).*/, "$1") + "/thumbnails?version="+Math.random();
    } else if(PIC_TYPE.indexOf(ext) > -1){  //图片类型
        return url;
    } else if(AUDIO_TYPE.indexOf(ext) > -1){ //音频 类型
        return AUDIO
    } else if(ATTCHMENT_TYPE.indexOf(ext)>-1) {  //附件类型
        ext = ext.toLowerCase();
        if (ext === 'pdf') {
            return PDF
        } else if (ext === 'rar') {
            return RAR
        } else if (ext === 'txt') {
            return TXT
        } else if (ext === 'docx' || ext === 'doc') {
            return WORD
        } else if (ext === 'xlsx' || ext === 'xls') {
            return XLXS
        } else if (ext === 'zip' || ext === "tar" || ext === "gz") {
            return ZIP
        } else if (ext === 'ppt' || ext === 'pptx') {
            return PPT
        } else {
            return File;
        }
    }
};

class UploadWall extends Component {

    /**
     * 模拟上传按钮点击，只有 showUploadDisplayBtn属性为true时才起作用
     */
    uploadDisplayBtnClick = ()=>{
        this.uploadDisplayBtn.click();
    };

    areaId = "a"+uuid().replace(/-/g,"_");

    getUploadBtnComponent(size){
        if(this.props.uploadBtnComponent){
            return this.props.uploadBtnComponent(size);
        }
        return <div style={{
            width: size + "px",
            height: size + "px",
            backgroundColor: "#ffffff",
            border: "dashed 1px #b2bbd5",
            cursor: "default",
            /*flex 布局*/
            display: "flex",
            /*实现垂直居中*/
            alignItems: "center",
            /*实现水平居中*/
            justifyContent: "center",
            backgroundImage: `url(${this.props.imageUrl})`,
            backgroundSize: "contain",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat"
        }}>
            {
                this.props.imageUrl?
                    "":<div>
                        <img src={uploadIcon} width="20"
                             style={{margin: "0 auto 8px auto", display: "block"}}/>
                        <span>{this.props.uploadBtnName}</span>
                    </div>
            }
        </div>;
    };

    /**
     *  同步服务端修改文件名
     * @param {*} isSyncModifiedFileName 是否开启同步服务端修改文件名
     * @param {*} params  被修改文件参数{ 文件名(name),文件md5值}
     * @param {*} callBack  修改成功后回调函数
     * @param {*} comInstance  调用组件实例(可选)
     */
    syncModifiedFileName(isSyncModifiedFileName) {

        return function(params,callBack,comInstance) {
            
            if (isSyncModifiedFileName) {
                
                if (( typeof this.request !== 'function')  && ( typeof comInstance.request !== 'function')&& (typeof window.request !== 'function')) {
                    throw new TypeError('This Function is missing an instance component that calls the request method');
                }
                
                // 用于判断调用request的实例
                const instance =(typeof comInstance.request === 'function' && comInstance) || (typeof this.request === 'function' && this) || (typeof window.request === 'function' && window);
                instance.request({
                    url: '/storage/reName',
                    method: 'post',
                    body: params,
                    contentType: 'json',
                    callBack: (response)=>{
                        if(response) {
                            callBack();
                        }
                    },
                })
            }else {
                if (typeof callBack ==='function')   callBack();
            }
        }
    }

    render() {
        const size = 130;
        let Token = getInfoFromLocalStorage('Token');
        let Top = this.props.Top?this.props.Top:0;
        let right= this.props.right?this.props.right:0;
        let marginBottom = this.props.marginBottom?this.props.marginBottom:10;
        let content ='';
        let showEmpty =  this.props.showEmpty?this.props.showEmpty:false;
        if(showEmpty){
            content = <div></div>
        }else{
            content = <Empty/>
        }
        return (
            !(this.props.showUploadBtn || this.props.showUploadDisplayBtn) && (!this.props.fileList || this.props.fileList.length === 0 )?content:
            <div style={{width:"100%", backgroundColor:"#fff", overflow: 'hidden',
                padding:this.props.listType === "list"?"0px":"32px 0px 0px 40px",...this.props.style}} id={this.areaId}>
                <div style={(()=>{
                    return !this.props.showUploadBtn?this.props.showUploadDisplayBtn?{height:0}:{}:this.props.listType === "list" ?
                        {marginRight:right,marginTop:Top,marginBottom:marginBottom,}:
                        {marginRight:"20px",marginBottom:"32px",float:"left",width:130,height:130}
                })()}>
                    <Upload
                        {...this.props}
                        headers={{Authorization : 'Bearer ' + Token}}
                        listType={'text'}
                        showUploadList={false}
                    >
                        {
                            this.props.listType === "list"
                                ?
                                (this.props.showUploadBtn
                                        ? (typeof this.props.uploadBtnName == "object" ?
                                                this.props.uploadBtnName
                                                :
                                                <Button><Icon
                                                    type="upload"/>{this.props.uploadBtnName ? this.props.uploadBtnName : '点击上传'}
                                                </Button>
                                        )
                                        :  this.props.showUploadDisplayBtn?<div style={{height:0}} ref={(uploadDisplayBtn)=>this.uploadDisplayBtn = uploadDisplayBtn}/>:null
                                )
                                :
                                (this.props.showUploadBtn ? this.getUploadBtnComponent(size) : this.props.showUploadDisplayBtn?<div style={{height:0}} ref={(uploadDisplayBtn)=>this.uploadDisplayBtn = uploadDisplayBtn}/>:null)
                        }
                    </Upload>
                </div>
                {
                    this.props.describe?<div style={{lineHeight:"1.2",color:"rgba(0,0,0,.45)",fontSize:"12px"}}>{this.props.describe}</div>:""
                }
                {this.props.fileList&&this.props.fileList.length>0 && this.props.fileList.map((item, index)=>{
                    let key = item.uid || index
                    if(this.props.fileItemComponent){
                        let FileItemComponent = this.props.fileItemComponent;
                        if (!(FileItemComponent.prototype instanceof Component) && (typeof FileItemComponent === "function")) {
                            let renderItem = FileItemComponent;
                            FileItemComponent = renderItem(item, index);
                        }
                        return <FileItemComponent
                            {...this.props}
                            key={key}
                            onPreview={this.props.onPreview}
                            onRemove={this.props.onRemove}
                            onPlay={this.props.onPlay}
                            onDownload={this.props.onDownload}
                            icons={this.props.icons}
                            showPercent={this.props.showPercent}
                            cancelUpload={this.props.cancelUpload}
                            isSyncModifiedFileNameFn={this.syncModifiedFileName(this.props.isSyncModifiedFileName)}
                            onEditFileNameCall={(file, fileName)=>{
                                this.props.onEditFileNameCall && this.props.onEditFileNameCall(file, fileName)
                            }}
                            size={size} file={item} index={index}/>
                    }
                    if(this.props.listType === "list"){
                        return <FileListItem
                            key={key}
                            onPreview={this.props.onPreview}
                            onRemove={this.props.onRemove}
                            onPlay={this.props.onPlay}
                            onDownload={this.props.onDownload}
                            icons={this.props.icons}
                            showPercent={this.props.showPercent}
                            size={size} file={item}
                            />
                    }
                    if(this.props.listType === "infoCard"){
                        return <FileInfoCard
                            key={key}
                            onPreview={this.props.onPreview}
                            onRemove={this.props.onRemove}
                            onPlay={this.props.onPlay}
                            onInsert={this.props.insertCall}
                            onDownload={this.props.onDownload}
                            icons={this.props.icons}
                            showPercent={this.props.showPercent}
                            size={size} file={item}
                            fileList={this.props.fileList}
                        />
                    }
                    return <FileBlock
                        key={key}
                        reUpload={this.props.reUpload}
                        onPreview={this.props.onPreview}
                        onRemove={this.props.onRemove}
                        onPlay={this.props.onPlay}
                        onDownload={this.props.onDownload}
                        onListen={this.props.onListen}
                        icons={this.props.icons}
                        size={size} file={item} />
                })}
            </div>
        );
    }
}
UploadWall.defaultProps={
    uploadBtnName: "上传文件",
    showUploadBtn:true,//默认显示
    listType:"card",
    showUploadDisplayBtn: false,
    style:{},
    isSyncModifiedFileName: false, //是否同步修改文件名
};


export class FileInfoCard extends BaseComponent{

    state={
        insertTextShow: false
    };


    renderMask(file, size){
        let percent = file.percent;
        let allWidth = size - 10;
        let msg = "上传中...";
        const speed = file.originFileObj && file.originFileObj.speed ? file.originFileObj.speed : null;
        if(percent === 100){
            if(file.response && file.response.path){
                return <>
                    <div onClick={()=>{this.props.onInsert && this.props.onInsert(file)}}
                         style={{textAlign:"center",display:this.state.insertTextShow?"block":"none",color:"#fff",position:"absolute",bottom:"0px",
                             width:"80px", height:"24px", background:"#999999", zIndex:999, cursor:"pointer"}}>插入正文</div></>;
            }else{
                msg = "处理中...";
            }
        }
        return <>
            <div style={{width:size,height:size, background:"#000",position:"absolute",zIndex:997,top:0,left:0,opacity:0.5}}/>
            <div style={{color:"#fff",position:"absolute",zIndex:999,top: speed ? 15 : 25,left:15}}>{msg}</div>
            {
                speed && <div style={{ width:"51px", color: "#fff", position: "absolute", zIndex: 999, top: 35, left: 15,}}>{speed}</div>
            }
            <div style={{width:allWidth,height:5,background:"#fff",position:"absolute",zIndex:998,left:5,bottom:18,borderRadius:5}}/>
            <div style={{width:allWidth * percent / 100,height:5,background:this.themeBgColor,position:"absolute",zIndex:998,left:5,bottom:18,borderRadius:5}}/>
        </>
    }

    render() {
        let audioPath = this.sysConfigGetValueByKey("icon_audio_path", "/storage/9D74B50D3E3967F15C39C0F15560B56F");
        let { file } = this.props;
        const { status, originFileObj:{name} } = file;
        const isError = status === "error";
        let width = 270;
        if(isError){
            return <div style={{
                float:"left",
                width,
                height: 100,
                margin:5,
                background:"#f6f8fd",
                padding:10,
                borderRadius: 5,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
            }}>
                <div style={{
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 3,
                    overflow: "hidden",
                }} title={`${name}上传出错`} >{name}上传出错</div>
                <div style={{fontSize: 12,color: "#0050b3",textAlign:"right"}}>
                    <span style={{ cursor: "pointer" }}
                        onClick={() => {
                            this.props.onRemove(file)
                        }}>删除</span>
                </div>
            </div>;
        }
        let suffix = getSubffix(name);
        const size = 80;
        if(AUDIO_TYPE.indexOf(suffix) !== -1){
            return <div style={{float:"left", width, height: 100, margin:5, background:"#f6f8fd", padding:10, borderRadius: 5}}>
                <table><tbody>
                <tr height={80}>
                    <td onMouseOver={()=>{
                        this.setState({insertTextShow:true})
                    }} onMouseOut={()=>{
                        this.setState({insertTextShow:false})
                    }} width={size} align={"center"} valign={"middle"} style={{position:"relative"}}>
                        <div style={{borderRadius: 5,overflow: "hidden"}}><img style={{objectFit:"cover"}} src={audioPath} height={80} width={80}/></div>
                        {this.renderMask(file, size)}
                    </td>
                    <td style={{padding:"0 10px"}}>
                        <Tooltip placement={"topLeft"} title={name}><div className={"text-pointer"} style={{width: width - 100}}><b>{name}</b></div></Tooltip>
                        <span>日期：{file.originalCreateTime && formatTime(file.originalCreateTime)}</span><br/>
                        <span>时长：{computeDuration(file.duration)}</span>
                        <div style={{fontSize: 12,color: "#0050b3",marginLeft:100}}>
                            <span style={{marginRight:10,cursor:"pointer"}} onClick={()=>{this.detailDialogAudio.show()}}>预览</span>
                            <span style={{cursor: "pointer"}}
                                  onClick={() => {
                                      this.props.onRemove(file)
                                  }}>删除</span>
                        </div>
                    </td>
                </tr>
                </tbody></table>
                <Audio ref={ref=>this.detailDialogAudio=ref} path={file.path}/>
            </div>;
        }else if(PIC_TYPE.indexOf(suffix) !== -1){

            const windowURL = window.URL || window.webkitURL;

            const src = file.smallPath?file.smallPath:windowURL.createObjectURL(file.originFileObj);

            return <div style={{float:"left", width, height: 100, margin:5, background:"#f6f8fd", padding:10, borderRadius: 5}}>
                <table><tbody>
                <tr height={80}>
                    <td onMouseOver={()=>{
                        this.setState({insertTextShow:true})
                    }} onMouseOut={()=>{
                        this.setState({insertTextShow:false})
                    }} width={size} align={"center"} valign={"middle"} style={{position:"relative"}}>
                        <div style={{borderRadius: 5,overflow: "hidden"}}><img style={{objectFit:"cover"}} src={src} height={80} width={80}/></div>
                        {this.renderMask(file, size)}
                    </td>
                    <td style={{padding:"0 10px"}}>
                        <Tooltip placement={"topLeft"} title={name}><div className={"text-pointer"} style={{width: width - 100}}><b>{name}</b></div></Tooltip>
                        <span>日期：{file.originalCreateTime && formatTime(file.originalCreateTime)}</span><br/>
                        <span>尺寸：{file.width?file.width:0} * {file.height?file.height:0}</span>
                        <div style={{fontSize: 12,color: "#0050b3",marginLeft:100}}>
                            <span style={{marginRight:10,cursor:"pointer"}} onClick={()=>{this.detailDialog.show()}}>预览</span>
                            <span style={{cursor: "pointer"}}
                                  onClick={() => {
                                      this.props.onRemove(file)
                                  }}>删除</span>
                        </div>
                    </td>
                </tr>
                </tbody></table>
                <Picture ref={ref=>this.detailDialog=ref} path={file.path}/>
            </div>;
        } else if(VIDEO_TYPE.indexOf(suffix) !== -1){
            let src = videoIcon;
            if(file.response && file.response.thumbnailsPlayPath){
                src = file.response.thumbnailsPlayPath;
            }
            return <div style={{float:"left", width, height: 100, margin:5, background:"#f6f8fd", padding:10, borderRadius: 5}}>
                <table><tbody>
                <tr height={80}>
                    <td onMouseOver={()=>{
                        this.setState({insertTextShow:true})
                    }} onMouseOut={()=>{
                        this.setState({insertTextShow:false})
                    }} width={size} align={"center"} valign={"middle"} style={{position:"relative"}}>
                        <div style={{borderRadius: 5,overflow: "hidden"}}><img style={{objectFit:"cover"}} src={src} height={80} width={80}/></div>
                        {this.renderMask(file, size)}
                    </td>
                    <td style={{padding:"0 10px"}}>
                        <Tooltip placement={"topLeft"} title={name}><div className={"text-pointer"} style={{width: width - 100}}><b>{name}</b></div></Tooltip>
                        <span>日期：{file.originalCreateTime && formatTime(file.originalCreateTime)}</span><br/>
                        <span>时长：{computeDuration(file.duration)}</span>
                        <div style={{fontSize: 12,color: "#0050b3",marginLeft:100}}>
                            <span style={{marginRight:10,cursor:"pointer"}} onClick={()=>{this.detailDialogVideo.show()}}>预览</span>
                            <span style={{cursor: "pointer"}}
                                  onClick={() => {
                                      this.props.onRemove(file)
                                  }}>删除</span>
                        </div>
                    </td>
                </tr>
                </tbody></table>
                <Video ref={ref=>this.detailDialogVideo=ref} path={file?.mp4Path || file?.path}/>
            </div>;
        }

        // <Audio ref={ref=>this.detailDialogAudio=ref} path={this.state.newPath}/>
        // <Video ref={ref=>this.detailDialogVideo=ref} path={this.state.newPath}/>
        // if(file.stateStr){
        //     if(file.stateStr==='完成'){
        //         file.url = file.url.replace(/(\/storage\/[a-zA-Z0-9]{32}).*/, "$1") + "/thumbnails"//"?version="+Math.random();
        //         if(!file.url){
        //             return <div>文件url不存在,上传出错</div>
        //         }
        //         return <div style={{float:"left", width:240, height: 100, margin:5, background:"#f6f8fd", padding:10, borderRadius: 5}}>
        //             <table><tbody>
        //             <tr>
        //                 <td width={70}><div style={{borderRadius: 5,overflow: "hidden"}}><img src={audioPath} width={70}/></div></td>
        //                 <td></td>
        //             </tr>
        //             </tbody></table>
        //
        //         </div>;
        //     }else{
        //         file.ingStatus = file.stateStr;
        //     }
        // }
        // if(file.url){
        //     return <div>文件url不存在,上传出错</div>
        // }
        // return <div style={{float:"left", width:240, height: 100, margin:5, background:"#f6f8fd", padding:10, borderRadius: 5}}>
        //     {file.ingStatus}
        // </div>;
    }
}

export class FileListItem extends Component{

    state={shade:false};

    render() {
        const errorColor = "#f56c6c"
        const { status } = this.props.file;
        const isError = status === "error";
        const title = this.props.file.url || isError ?
            this.props.file.name :
            (this.props.file.ingStatus ? this.props.file.ingStatus : "加载中，请稍后...");
            const speed = this.props.file?.originFileObj && this.props.file.originFileObj.speed ? this.props.file.originFileObj.speed : null;
        return <table className={"upload-wall-file-list"} cellSpacing={0} cellPadding={0} border={0} width={"100%"} onMouseOver={(e)=>{this.setState({shade:true})}} onMouseOut={(e)=>this.setState({shade: false})} >
            <tbody>
            {this.props.showPercent?<>
                <tr>
                    <td rowSpan={2} width={42} valign={"middle"}>
                        <Icon
                            type={isError ? "disconnect" : "api"}
                            style={{fontSize:"25px", color: isError ? errorColor : ""}}
                        />
                    </td>
                    <td>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div
                                style={{ color: isError ? errorColor : "", overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 115 }}
                                title={title}
                            >
                                {title}
                            </div>
                            {
                                speed && <div style={{ fontSize: 12, marginRight: 10 }}>当前速度：{speed}</div>
                            }
                        </div>
                    </td>
                    <td rowSpan={2} width={50} valign={"middle"} align={"center"}>
                        <div style={{display:this.state.shade?"block":"none"}}>
                            {this.props.icons.indexOf("download")!==-1?<Icon type={"download"} onClick={()=>{
                                this.props.onDownload(this.props.file);
                            }} style={{fontSize:20}}/>:""}

                            {this.props.icons.indexOf("delete")!==-1?<Icon type={"close-circle"} onClick={()=>{
                                this.props.onRemove(this.props.file);
                            }} style={{marginLeft:"10px",fontSize:20}}/>:""}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td><Progress strokeColor={isError ? errorColor : ""} status={isError ? "exception" : this.props.file.url ? "success" : ""}  percent={this.props.file.url?100:parseInt(this.props.file.percent)} /></td>
                    <td></td>
                </tr>
            </>:null}
            </tbody>
        </table>
    }

}
FileListItem.defaultProps={
    file:{
        ingStatus:"加载中"//有的时候不是加载中，比如视频上传完了之后会有多种形态，比如合并中，转码中等，这个时候就需要外面把状态传进来
    },
    icons:["download", "delete"],
    onPreview:()=>{},
    onRemove:()=>{},
    onDownload:(file)=>{
        if(file.url.indexOf("?") === -1){
            window.location.href = file.url + "?download=1";
        }else{
            window.location.href = file.url + "&download=1";
        }
    },
    onPlay:()=>{},
    showPercent:true
};

export class FileBlock extends Component{

    state={shade:false};

    getFileUrl = (file) => {
        file.url = getFileImage(file.url, file.ext);
        return file;
    };

    render() {
        const {file} =this.props;
        if(file.stateStr){
            if(file.stateStr==='完成'){
                file.url = file.url.replace(/(\/storage\/[a-zA-Z0-9]{32}).*/, "$1") + "/thumbnails"//"?version="+Math.random();
            }else{
                file.ingStatus = file.stateStr;
            }
        }else{
            if(file.ext){
                file.url = getFileImage(file.url, file.ext);
            }
        }
        let ext = "";
        if(this.props.file.name){
            ext = getSubffix(this.props.file.name);
        }
        const speed = file.originFileObj && file.originFileObj.speed ? file.originFileObj.speed : null;
        const padding = 20;
        const descHeight = 20;
        const uploadingEl = <div style={{textAlign:"center"}}>
            <Icon type="sync" style={{fontSize:"30px",margin: "0 auto 8px auto",display: "block",color:"#a4adc8"}} spin />
            <span style={{color:"#a4adc8"}}>{this.props.file.percent?`上传中${parseInt(this.props.file.percent)}%`:"等待中"}</span>
            {
                speed && <div style={{color:"#a4adc8",fontSize:12}}>速度：{speed}</div>
            }
        </div>;
        const loadingEl = <div>
            <img src={uploadingIcon} width="30" style={{margin: "0 auto 8px auto",display: "block"}} />
            <span style={{color:"#a4adc8"}}>{this.props.file.ingStatus?this.props.file.ingStatus:"加载中"}</span>
        </div>;
        let isShowLeft = false;

        let isShowLoadingState = !this.props.file.url || (file.stateStr && file.stateStr!=='完成');
        // console.log("this.props.file.status !== \"done\":    ", this.props.file, this.props.file.status, this.props.file.status !== "done");
        return (
            <div
                title={this.props.file.title ? this.props.file.title : ''}
                onMouseOver={(e)=>{this.setState({shade:true})}} onMouseOut={(e)=>this.setState({shade: false})}
                style={{width: this.props.size+"px",height: this.props.size+"px", backgroundColor: "#f4f6fc",
                cursor: "default",
                marginRight:"20px",
                marginBottom:"32px",
                float:"left",
                /*flex 布局*/
                display: "flex",
                /*实现垂直居中*/
                alignItems: "center",
                /*实现水平居中*/
                justifyContent: "center",
                position:"relative",
                ...this.props.style
            }}>
                {(this.props.file.status !== "done")?uploadingEl
                    :isShowLoadingState ?loadingEl:
                    <div style={{width: this.props.size - padding + "px",height: this.props.size - padding + "px",textAlign:"center"}}>
                        {this.props.file.icon?this.props.file.icon:
                            <div style={{ width: this.props.size - padding, height:this.props.size - padding - descHeight, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                <img src={this.props.file.smallPath || this.props.file.url}
                                     style={{ width: "100%",height: "100%",objectFit: "contain"}} alt=""/>
                            </div>}
                            <Tooltip placement={"bottomLeft"} title={this.props.file.name}>
                                <div style={{textAlign:"center", lineHeight:"22px", whiteSpace: "nowrap",overflow: "hidden", textOverflow: "ellipsis"}}>{this.props.file.name}</div>
                            </Tooltip>
                    </div>}

                {/*{"这下面和上面判断是一样的，下面是遮罩的显示"}*/}
                {!this.props.shade?"":(this.props.file.status !== "done")?""
                    :isShowLoadingState ?"":
                <div style={{width:"100%", height:"calc(100% - 30px)",textAlign:"center", backgroundColor:'rgba(0,0,0,0.65)',position:"absolute",top:"0px",left:"0px",display:this.state.shade?"block":"none"}}>
                    {(this.props.icons.indexOf("eye")!==-1 && (!ext || (PIC_TYPE.indexOf(ext)!==-1)))?(()=>{
                        let res = <Icon type={"eye"} onClick={()=>{
                            this.props.onPreview(this.props.file);
                        }} style={{marginTop:"44px",color:"#fff",fontSize:20}}/>
                        isShowLeft = true;
                        return res;
                    })():""}

                    {(this.props.icons.indexOf("play")!==-1 && (!ext || (VIDEO_TYPE.indexOf(ext)!==-1)))?(()=>{
                        let res = <Icon type={"play-circle"} onClick={()=>{
                            this.props.onPlay(this.props.file);
                        }} style={{marginTop:"44px",marginLeft:isShowLeft?"10px":"0px",color:"#fff",fontSize:20}}/>
                        isShowLeft = true;
                        return res;
                    })():""}

                    {(this.props.icons.indexOf("listen")!==-1 && (!ext || (AUDIO_TYPE.indexOf(ext)!==-1)))?(()=>{
                        let res = <Icon type={"customer-service"} onClick={()=>{
                            this.props.onListen(this.props.file);
                        }} style={{marginTop:"44px",marginLeft:isShowLeft?"10px":"0px",color:"#fff",fontSize:20}}/>
                        isShowLeft = true;
                        return res;
                    })():""}

                    {this.props.icons.indexOf("download")!==-1?(()=>{
                        let res = <Icon type={"download"} onClick={()=>{
                            this.props.onDownload(this.props.file);
                        }} style={{marginTop:"44px",marginLeft:isShowLeft?"10px":"0px",color:"#fff",fontSize:20}}/>
                        isShowLeft = true;
                        return res;
                    })():""}

                    {this.props.icons.indexOf("delete")!==-1?<Icon type={"delete"} onClick={()=>{
                        this.props.onRemove(this.props.file);
                    }} style={{marginTop:"44px",marginLeft:isShowLeft?"10px":"0px",color:"#fff",fontSize:20}}/>:""}

                </div>}
                {
                    this.props.reUpload && (this.props.file.status == "error") && <div style={{width:"100%", height:"100%",textAlign:"center", backgroundColor:'rgba(0,0,0,0.65)',position:"absolute",top:"0px",left:"0px",display:this.state.shade?"block":"none"}}>
                        <Icon type={"redo"} title={'重新上传'} onClick={()=>{

                            this.props.reUpload(this.props.file.uid);
                        }} style={{marginTop:"44px",marginLeft:isShowLeft?"10px":"0px",color:"#fff",fontSize:20}}/>
                    </div>
                }
            </div>);
    }
}
FileBlock.defaultProps={
    size: 100,
    style:{},
    file:{
        ingStatus:"加载中"//有的时候不是加载中，比如视频上传完了之后会有多种形态，比如合并中，转码中等，这个时候就需要外面把状态传进来
    },
    icons:["eye", "play", "download", "delete"],
    shade:true,//显示鼠标悬浮时的遮罩
    onPreview:()=>{},
    onRemove:()=>{},
    onDownload:(file)=>{
        if(file.url.indexOf("?") === -1){
            window.location.href = file.url + "?download=1";
        }else{
            window.location.href = file.url + "&download=1";
        }
    },
    onPlay:()=>{}
};
export default UploadWall;
